var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "section-title" }, [
        _c("div", [
          _c("h2", [
            _vm._v(_vm._s(_vm.$t("collectionOperationDashboard.sectionTitle"))),
          ]),
          _c("p", [
            _vm._v(_vm._s(_vm.$t("collectionOperationDashboard.sectionDesc"))),
          ]),
        ]),
        _c(
          "div",
          { staticClass: "export-actions" },
          [
            _c(
              "el-button",
              { attrs: { size: "small" }, on: { click: _vm.handleExport } },
              [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$t("collectionOperationDashboard.exportCityDetail")
                    ) +
                    " "
                ),
              ]
            ),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "data-contract" }, [
        _c("span", { staticClass: "contract-label" }, [
          _vm._v(_vm._s(_vm.$t("collectionOperationDashboard.dataContract"))),
        ]),
        _c("span", { staticClass: "contract-item" }, [
          _vm._v(_vm._s(_vm.$t("collectionOperationDashboard.collectScan"))),
        ]),
        _c("span", { staticClass: "contract-split" }, [_vm._v("→")]),
        _c("span", { staticClass: "contract-item" }, [
          _vm._v(_vm._s(_vm.$t("collectionOperationDashboard.firstLoading"))),
        ]),
        _c("span", { staticClass: "contract-split" }, [_vm._v("→")]),
        _c("span", { staticClass: "contract-item" }, [
          _vm._v(_vm._s(_vm.$t("collectionOperationDashboard.closedLoop"))),
        ]),
        _c("span", { staticClass: "coverage-chip" }, [
          _vm._v(
            _vm._s(_vm.$t("collectionOperationDashboard.nationwideDrill"))
          ),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "kpis" },
        _vm._l(_vm.kpiList, function (kpi, index) {
          return _c(
            "div",
            {
              key: index,
              staticClass: "kpi",
              style: { "--tone": kpi.tone, "--accent": kpi.accent },
            },
            [
              _c(
                "div",
                { staticClass: "label" },
                [
                  _c("span", { staticClass: "label-left" }, [
                    _c("i", { staticClass: "kpi-icon" }, [
                      _vm._v(_vm._s(kpi.icon)),
                    ]),
                    _vm._v(" " + _vm._s(_vm.$t(kpi.labelKey)) + " "),
                  ]),
                  _c(
                    "el-tooltip",
                    {
                      attrs: { content: _vm.$t(kpi.descKey), placement: "top" },
                    },
                    [_c("i", { staticClass: "el-icon-info help-icon" })]
                  ),
                ],
                1
              ),
              _c("strong", [_vm._v(_vm._s(kpi.value))]),
              _c("small", [_vm._v(_vm._s(_vm.$t(kpi.descKey)))]),
              kpi.exportType
                ? _c(
                    "el-tooltip",
                    {
                      attrs: {
                        content: _vm.$t(
                          "collectionOperationDashboard.exportList"
                        ),
                        placement: "top",
                      },
                    },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "kpi-export",
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              return _vm.handleKpiExport(kpi)
                            },
                          },
                        },
                        [_c("i", { staticClass: "el-icon-download" })]
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            1
          )
        }),
        0
      ),
      _c(
        "el-row",
        { staticClass: "chart-grid", attrs: { gutter: 12 } },
        [
          _c("el-col", { attrs: { md: 8, sm: 24, xs: 24 } }, [
            _c("div", { staticClass: "card" }, [
              _c("div", { staticClass: "card-head" }, [
                _c("div", [
                  _c("h3", [
                    _vm._v(
                      _vm._s(_vm.$t("collectionOperationDashboard.trendTitle"))
                    ),
                  ]),
                  _c("p", [
                    _vm._v(
                      _vm._s(_vm.$t("collectionOperationDashboard.trendDesc"))
                    ),
                  ]),
                ]),
              ]),
              _c("div", { ref: "trendChart", staticClass: "chart" }),
            ]),
          ]),
          _c("el-col", { attrs: { md: 8, sm: 24, xs: 24 } }, [
            _c("div", { staticClass: "card" }, [
              _c("div", { staticClass: "card-head" }, [
                _c("div", [
                  _c("h3", [
                    _vm._v(
                      _vm._s(
                        _vm.$t("collectionOperationDashboard.customerTitle")
                      )
                    ),
                  ]),
                  _c("p", [
                    _vm._v(
                      _vm._s(
                        _vm.$t("collectionOperationDashboard.customerDesc")
                      )
                    ),
                  ]),
                ]),
              ]),
              _c("div", { ref: "clientChart", staticClass: "chart" }),
            ]),
          ]),
          _c("el-col", { attrs: { md: 8, sm: 24, xs: 24 } }, [
            _c("div", { staticClass: "card" }, [
              _c("div", { staticClass: "card-head" }, [
                _c("div", [
                  _c("h3", [
                    _vm._v(
                      _vm._s(
                        _vm.$t("collectionOperationDashboard.serviceTitle")
                      )
                    ),
                  ]),
                  _c("p", [_vm._v("W2D / D2D / SFS")]),
                ]),
              ]),
              _c("div", { ref: "serviceChart", staticClass: "chart" }),
            ]),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }